import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { DocumentsRepositoryService } from '../../services/document/documents-repository.service';
import { base64StringToBlob } from 'blob-util';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-document-download',
    templateUrl: './document-download.component.html',
    styleUrls: ['./document-download.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentDownloadComponent {
  private readonly transloco = inject(TranslocoService);
    @Input({ required: true }) documentID!: string | null | undefined;
    private _documentName?: string;
    @Input() set documentName(value: string | null | undefined) { this._documentName = value ?? undefined; }
    get documentName(): string { return this._documentName ?? this.transloco.translate('common.labels.document'); }

    constructor(private documentsRepo: DocumentsRepositoryService) { }

    downloadDocument() {
        if (this.documentID) {
            //Get Document
            this.documentsRepo.getDocument(this.documentID!)
                .subscribe(result => {
                    const documentType = `application/${result?.documentTypeID ?? "pdf" }`.toLowerCase();
                    const blob = base64StringToBlob(result.base64, documentType);
                    const blobURL = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = blobURL;
                    link.download = result.fileName; // set a name for the file
                    link.click();
                });
        }
    }
}